import React from 'react'

import StepCounter from '~/components/step-counter'
import { i18n } from '~/i18n'
import {
  WAIVERS_STEP_NUMBER,
  ASSIGN_PASSES_STEP_NUMBER,
  PAYMENT_STEP_NUMBER,
  REVIEW_STEP_NUMBER,
  urlFromStep,
} from '~/utils/step'

import { Wrapper } from './step-counter-checkout.styles'
import Icon from '../icon'

import type { Props } from './step-counter-checkout.types'

const getSteps = ({ affirmEnabled }) => [
  {
    icon: <Icon glyph="user" />,
    subtitle: i18n.t('components.checkout_step_counter.one_subtitle'),
    to: urlFromStep(ASSIGN_PASSES_STEP_NUMBER),
    stepNum: ASSIGN_PASSES_STEP_NUMBER,
  },
  {
    icon: <Icon glyph="tag" />,
    subtitle: i18n.t('components.checkout_step_counter.two_subtitle'),
    to: urlFromStep(WAIVERS_STEP_NUMBER),
    stepNum: WAIVERS_STEP_NUMBER,
  },
  {
    icon: <Icon glyph="credit-card" />,
    subtitle: affirmEnabled
      ? i18n.t('components.checkout_step_counter.three_subtitle_v2')
      : i18n.t('components.checkout_step_counter.three_subtitle'),
    to: urlFromStep(PAYMENT_STEP_NUMBER),
    stepNum: PAYMENT_STEP_NUMBER,
  },
  {
    icon: <Icon glyph="check" />,
    subtitle: i18n.t('components.checkout_step_counter.four_subtitle'),
    stepNum: REVIEW_STEP_NUMBER,
  },
]

export default function StepCounterCheckout({
  affirmEnabled,
  currentStep,
}: Props) {
  return (
    <Wrapper>
      <StepCounter
        steps={getSteps({
          affirmEnabled,
        })}
        currentStep={currentStep}
      />
    </Wrapper>
  )
}
